import { useAppSelector } from '@/hooks'
import { selectCanManage } from '@/features/auth/authSlice'
import { useIntegrationConnections } from '@/hooks/useIntegrationConnections'

/** Only a linked Rock has a setup to finish. */
export const LINKED_ROCK_FILTER = { filters: { provider: 'rockrms', status: 'linked' } }

/**
 * The tenant's linked Rock connection and whether its guided setup is
 * unfinished, for the app shell (banner, sidebar item) and Getting started.
 *
 * "Pending" is the connection's own `onboarding_pending` (backend T1: a
 * linked, active Rock whose `onboarding_state` isn't `done`), read from the
 * connections list: no board fetch and no Rock round trip, so a slow or
 * unreachable Rock can never hide it. Administrators only, the people who
 * can act on it. The list query is shared with the Integrations page.
 *
 * `isLoading`: the list hasn't answered yet, so no connection doesn't mean no Rock.
 *
 * @returns {{connection: Object|undefined, canManage: boolean, isPending: boolean, isLoading: boolean}}
 */
export function useLinkedRockSetup() {
  const canManage = useAppSelector(selectCanManage)
  const connectionsQuery = useIntegrationConnections(LINKED_ROCK_FILTER)
  const connections = connectionsQuery.data || []
  // A pending connection wins, so a second, finished Rock can't hide it.
  const connection = connections.find((candidate) => candidate.onboarding_pending === true) || connections[0]
  return {
    connection,
    canManage,
    isPending: canManage && connection?.onboarding_pending === true,
    isLoading: connectionsQuery.isLoading,
  }
}

export default useLinkedRockSetup
